var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"fab":"","color":"primary","x-small":"","disabled":_vm.loading},on:{"click":_vm.getAnswer}},[(_vm.loading)?_c('v-progress-circular',{attrs:{"indeterminate":"","size":"28"}}):_c('v-icon',[_vm._v("mdi-robot")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }